import HTMLReactParser from "html-react-parser";
import React from "react";

import backgrounds from "../../../assets/images/buildings/backgrounds";
import buildings from "../../../assets/images/buildings/buildings";

interface IProps {
  slot: any;
  tileTypeId: number;
}

const BuildingInfo = (props: IProps) => {
  const slotTypeId = props.slot.type.id || props.slot.activeType.id;
  return (
    <div className="manors">
      <div className={`manor single-manor ${slotTypeId === 0 ? "field" : ""}`}>
        <div className="image">
          <img src={slotTypeId === 0
            ? backgrounds[`background${props.tileTypeId}`]
            : buildings[`b${slotTypeId}`]} alt=""
          />
          {
            slotTypeId
              ? <>
                {props.slot.inDemolition
                  ? <>
                    <div className="overlay" style={{ height: "100%" }}/>
                    <span className="info">
                        <span className="text-bigger">DEMOLITION</span><br/>
                        Remaining turns: 1
                      </span>
                    <a className="btn btn-blank btn-no-width btn-no-height">Cancel</a>
                  </> : <></>
                }
                {props.slot.turnsToBuilt
                  ? <>
                    <div className="overlay" style={{ height: `${props.slot.toBuiltPercents}%` }}/>
                    <span className="progress positive" style={{ top: `${props.slot.toBuiltPercents}%` }}/>
                    <span className="info">
                      <strong className="number">
                        {Math.round(100 - props.slot.toBuiltPercents)}
                        <span className="space"> </span>%
                      </strong>
                      Remaining turns: {props.slot.turnsToBuilt}
                    </span></>
                  : <></>
                }
                {props.slot.damaged && !props.slot.turnsToBuilt
                  ? <>
                    <div className="overlay" style={{
                      height: `${props.slot.repaired && props.slot.repairTurns
                        ? 100 * (1 - props.slot.turnsToRepair / props.slot.repairTurns) : 0
                      }%`
                    }}/>
                    <span className="progress negative" style={{
                      top: `${props.slot.repaired && props.slot.repairTurns
                        ? 100 * (1 - props.slot.turnsToRepair / props.slot.repairTurns) : 0
                      }%`
                    }}/>
                    <span className="info">
                      {props.slot.repaired
                        ? <>
                          <span className="text-bigger">REPAIRING</span><br/>
                          Remaining turns: {props.slot.turnsToRepair}<br/>
                        </>
                        : <>
                          <strong className="number">
                            {Math.round(100 - props.slot.health * 100)}
                            <span className="space"> </span>%
                          </strong>
                          Damaged
                        </>}
                    </span></> : <></>
                }
                {props.slot.turnsToUpgrade
                  ? <>
                    <div className="overlay" style={{ height: `${props.slot.toUpgradePercents}%` }}/>
                    <span className="progress positive" style={{ top: `${props.slot.toUpgradePercents}%` }}/>
                    <span className="info">
                      <strong className="number">
                        {Math.round(100 - props.slot.toUpgradePercents)}
                        <span className="space"> </span>%
                      </strong>
                      <span className="text-bigger">UPGRADE</span><br/>
                      Remaining turns: {props.slot.turnsToUpgrade}
                    </span>
                  </> : <></>
                }
              </>
              : <></>
          }
        </div>
        <div className="text">
          {slotTypeId === 0
            ? <table>
              <tr>
                <td>
                  <a className="btn btn-blank btn-no-width btn-no-height"
                     data-params="{{ slot.id }}" data-toggle="manors" data-trigger="hover">Build building</a>
                </td>
              </tr>
            </table>
            : <>
              <h3 className="h3">{props.slot.activeType.name}</h3>
              <p className="white">{HTMLReactParser(props.slot.activeType.descriptionHtml)}</p>
              {props.slot.activeType.maintenance
                ? <p>
                  -{props.slot.activeType.maintenance}
                  <i className="icon icon-standalone icon-zlato gold align-sub"/> per turn
                </p>
                : <></>
              }
              <p>
                Hp: {props.slot.hp} / {props.slot.fullHp}
              </p>
              {props.slot.turnsToBuilt === 0 && !props.slot.inDemolition
                ? <div className="actions standalone-icons">
                  <div className="col-md-12 no-padding-left no-padding-right js-pops-{{ slot.id }}">
                    {props.slot.activeType.popPossible > 0
                      ? Array(props.slot.activeType.popPossible).fill(0)
                        .map(
                          (e: any, index: number) => (
                            props.slot.activeType.level < index + 1
                            && <i key={`pop${index}`} className="icon icon-xmd icon-zamek disabled"/>)
                            || (props.slot.pops < index + 1
                              ? <i key={`pop${index}`}
                                   className="icon icon-xmd icon-pop grey"
                              />
                              : <i key={`pop${index}`} className="icon icon-xmd icon-pop"/>)
                        )
                      : <i className="icon icon-xmd"/>}
                  </div>
                </div> : <></>}
            </>
          }

        </div>
      </div>
    </div>
  )
}

export default BuildingInfo;
